import { extendsModule, baseFormItem } from 'src/store/base';
import * as types from 'src/store/types';

export default extendsModule(baseFormItem, {
  state: {
    _moduleKey: 'procedural-creative-lib-auth',
    is_creative_authorized: false,
  },
  getters: {
    formItemData(state) {
      return {
        is_creative_authorized: state.is_creative_authorized,
      };
    },
  },
  mutations: {
    [types.UPDATE_PCD_CREATIVE_LIB_AUTH](state, val) {
      state.is_creative_authorized = val;
    },
  },
  actions: {
    data2State({ commit }, formData) {
      const data = {
        is_creative_authorized: !!formData.is_creative_authorized,
      };
      commit('update', data);
    },
  },
});
